<!-- 视频播放 -->
<template>
  <el-dialog title="" custom-class="dialog_center" :visible.sync="dialogVisible" @close="hide">
    <div class="videoPlay" v-loading="loading">
      <video class="videoPlay_video" :src="videoSrc" autoplay v-if="videoSrc"></video>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'video-play',
    data() {
      return {
        loading: false,
        dialogVisible: false, //弹框
        videoSrc: ''
      }
    },
    methods: {
      // 显示弹框
      play(src) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.videoSrc = src;
        })
      },
      hide() {
        setTimeout(() => {
          this.videoSrc = '';
        }, 300)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .videoPlay {
    max-width: 80vw;
    display: flex;
    align-items: center;
    justify-content: center;

    &_video {
      max-width: 100%;
      max-height: 60vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/video/video-play.vue